import React, { useState, useMemo } from 'react'
import { List, Upload, message, Input, Button } from 'antd'
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'
import { EGetUser, NPersonal, EPostUser } from '../../../../models/constants'
import { effect, useStore } from '../../../../dva16'
import './index.less'

export default function Material() {
  const [imageUrl, setImgUrl] = useState(null)
  const [loading, setLoading] = useState(false)
  const [editName, setEditName] = useState(false)
  const [editEmail, setEditEmail] = useState(false)
  const [editAbout, setEditAbout] = useState(false)

  const [NameVaule, setNameValue] = useState(null)
  const [EmailValue, setEmailValue] = useState(null)
  const [AboutValue, setAboutValue] = useState(null)
  const { userInfo } = useStore(NPersonal)
  useMemo(() => {
    effect(NPersonal, EGetUser)
  }, [])
  const uploadIndex = info => {
    if (info.file.status === 'done') {
      // 首页大图的上传成功回调
      setLoading(true)
      setImgUrl(info.file.response.url)
    } else if (info.file.status === 'error') {
      message.error('图片上传失败')
      setLoading(true)
    }
  }

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div className="ant-upload-text">Upload</div>
    </div>
  )
  return (
    <div id="Material">
      <List size="large" className="material-list">
        <List.Item>
          <div className="list-item">
            <p>我的头像</p>
            <div className="avatar">
              <Upload
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                action="http://s.stgame.cn/k3/client/v1/file"
                accept="image/*"
                onChange={info => uploadIndex(info)}
              >
                {imageUrl || userInfo.icon ? <img src={imageUrl || userInfo.icon} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
              </Upload>
              <p>点击图片修改</p>
            </div>
          </div>
        </List.Item>
        <List.Item>
          <div className="list-item">
            <p>昵称:</p>
            <div className="edit-center">
              {!editName && <span className="text">{userInfo.nickname}</span>}
              {editName && (
                <Input
                  onChange={e => {
                    setNameValue(e.target.value)
                  }}
                  defaultValue={userInfo.nickname}
                  style={{ width: 380 }}
                />
              )}
              <span onClick={() => setEditName(true)} className="editButton">
                编辑
              </span>
            </div>
          </div>
        </List.Item>
        <List.Item>
          <div className="list-item">
            <p>手机号:</p>
            <div className="edit-center">
              <span className="text">{userInfo.phone}</span>
            </div>
          </div>
        </List.Item>
        <List.Item>
          <div className="list-item">
            <p>邮箱:</p>
            <div className="edit-center">
              {!editEmail && <span className="text">{userInfo.email}</span>}
              {editEmail && (
                <Input
                  onChange={e => {
                    setEmailValue(e.target.value)
                  }}
                  defaultValue={userInfo.email}
                  style={{ width: 380 }}
                />
              )}
              <span onClick={() => setEditEmail(true)} className="editButton">
                编辑
              </span>
            </div>
          </div>
        </List.Item>
        <List.Item>
          <div className="list-item">
            <p>自我介绍:</p>
            <div className="edit-center">
              {!editAbout && <span className="text">{userInfo.introduce}</span>}
              {editAbout && (
                <Input
                  onChange={e => {
                    setAboutValue(e.target.value)
                  }}
                  defaultValue={userInfo.introduce}
                  style={{ width: 380 }}
                />
              )}
              <span onClick={() => setEditAbout(true)} className="editButton">
                编辑
              </span>
            </div>
          </div>
        </List.Item>
        <List.Item>
          <div className="list-item">
            <div className="save-button">
              <Button
                className="cancel"
                onClick={() => {
                  setEditName(false)
                  setEditAbout(false)
                  setEditEmail(false)
                }}
              >
                取消
              </Button>
              <Button
                className="save"
                onClick={() => {
                  let param = {
                    icon: imageUrl || userInfo.icon,
                    nickname: NameVaule || userInfo.nickname,
                    email: EmailValue || userInfo.email,
                    introduce: AboutValue || userInfo.introduce,
                  }
                  effect(NPersonal, EPostUser, param)
                  setEditName(false)
                  setEditAbout(false)
                  setEditEmail(false)
                }}
              >
                保存
              </Button>
            </div>
          </div>
        </List.Item>
      </List>
    </div>
  )
}
